import React from 'react';
import { Link } from 'react-router-dom';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <>
      <main>{children}</main>

      <footer className="footer">
        <div className="container">
          <div style={{ display: 'flex', justifyContent: 'center', gap: 'var(--space-xl)', flexWrap: 'wrap', marginBottom: 'var(--space-lg)' }}>
            <div>
              <p style={{ fontSize: '0.75rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.8px', color: 'var(--color-text-muted)', marginBottom: 'var(--space-sm)' }}>Quick Links</p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-xs)' }}>
                <Link to="/" style={{ fontSize: '0.9rem', color: 'var(--color-text-muted)', transition: 'color var(--transition-speed)' }} onMouseEnter={e => e.currentTarget.style.color = 'var(--color-primary)'} onMouseLeave={e => e.currentTarget.style.color = 'var(--color-text-muted)'}>Home</Link>
                <Link to="/about" style={{ fontSize: '0.9rem', color: 'var(--color-text-muted)', transition: 'color var(--transition-speed)' }} onMouseEnter={e => e.currentTarget.style.color = 'var(--color-primary)'} onMouseLeave={e => e.currentTarget.style.color = 'var(--color-text-muted)'}>About</Link>
                <Link to="/compare" style={{ fontSize: '0.9rem', color: 'var(--color-text-muted)', transition: 'color var(--transition-speed)' }} onMouseEnter={e => e.currentTarget.style.color = 'var(--color-primary)'} onMouseLeave={e => e.currentTarget.style.color = 'var(--color-text-muted)'}>Compare Tools</Link>
              </div>
            </div>
            <div>
              <p style={{ fontSize: '0.75rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.8px', color: 'var(--color-text-muted)', marginBottom: 'var(--space-sm)' }}>Contact</p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-xs)' }}>
                <a href="mailto:hello@chooseai.co.uk" style={{ fontSize: '0.9rem', color: 'var(--color-text-muted)', transition: 'color var(--transition-speed)' }} onMouseEnter={e => e.currentTarget.style.color = 'var(--color-primary)'} onMouseLeave={e => e.currentTarget.style.color = 'var(--color-text-muted)'}>hello@chooseai.co.uk</a>
                <a href="https://www.linkedin.com/in/choose-ai" target="_blank" rel="noopener noreferrer" style={{ fontSize: '0.9rem', color: 'var(--color-text-muted)', transition: 'color var(--transition-speed)' }} onMouseEnter={e => e.currentTarget.style.color = 'var(--color-primary)'} onMouseLeave={e => e.currentTarget.style.color = 'var(--color-text-muted)'}>LinkedIn</a>
              </div>
            </div>
          </div>
          <p style={{ fontSize: '0.85rem', color: 'var(--color-text-muted)' }}>&copy; 2026 ChooseAI. Helping you find the perfect AI tools.</p>
          <p style={{ fontSize: '0.85rem', color: 'var(--color-text-muted)', marginTop: 'var(--space-xs)' }}>
            This page may contain affiliate links. Find more information <Link to="/disclosure" style={{ color: 'var(--color-text-muted)', textDecoration: 'underline' }}>here</Link>.
          </p>
        </div>
      </footer>
    </>
  );
};

export default Layout;